import { useCallback, useState, useEffect } from "react";
import Main from "../../components/layouts/Main";
import PageTitle from "../../components/utils/PageTitle";
import { useUserContext } from "../../contexts/UserContext";
import Breadcrumb from "../../components/utils/Breadcrumb";
import { catchError } from "../../services/DaoService";
import {
  Button,
  Card,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Spin,
} from "antd";
import {
  PlusCircleFilled,
  ReloadOutlined,
} from "@ant-design/icons";
import { PersonnelService } from "../../services/PersonnelService";
import PersonnelCreateForm from "../../components/personnel/PersonnelCreateForm";
import PersonnelList from "../../components/personnel/PersonnelList";
import Toast from "../../helpers/Toast";
// import PropTypes from "prop-types";


export default function PersonnelListPage() {
  const [paginationData, setPaginationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [newModalVisible, setNewModalVisible] = useState(false);
  const { check } = useUserContext();
  const [searchText, setSearchText] = useState(null);
  const [statut, setStatut] = useState('tout');
  const [personnels, setPersonnels] = useState([]);

  const init = useCallback(() => {
    setLoading(true);
    PersonnelService.getInstance()
      .search({ searchText, statut })
      .then((response) => {
        setPaginationData(response.data);
        setPersonnels(response.data.data);
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [searchText, statut]);

  useEffect(() => {
    init();
  }, [init, check]);

  const handleCreation = () => {
    init();
  };

  const syncFromSiRH = () => {
    setLoading(true);
    PersonnelService.getInstance()
      .syncFromSiRH()
      .then((response) => {
        Toast.success(response.message);
        init();
      })
      .catch((error) => {
        catchError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const labelStyle = {
    marginRight: '10px',
    display: 'flex',
    alignItems: 'center',
  };

  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  };

  return (
    <Main>
      <Breadcrumb
        parentLink="/"
        canSee={check("VIEW-DASHBOARD")}
        parentLinkTitle="Accueil"
        title="Personnels"
      />
      <PageTitle
        title="Liste des personnels"
        subTitle="Gestion des personnels"
        icon={<PlusCircleFilled />}
      >
        {check("CREATE-PERSONNEL") && (
          <Button type="default" icon={<ReloadOutlined />} onClick={syncFromSiRH}>
            Synchroniser depuis SiRH
          </Button>
        )}
        {check("CREATE-PERSONNEL") && (
          <Button
            type="primary"
            icon={<PlusCircleFilled />}
            onClick={() => setNewModalVisible(true)}
          >
            Ajouter un personnel
          </Button>
        )}
        <Button type="default" icon={<ReloadOutlined />} onClick={init}>
          Rafraîchir
        </Button>
      </PageTitle>
      <Card>
        <Row gutter={[16, 16]} justify={"center"}>
          <Col span={24}>
            <Divider>Filtres rapides</Divider>
          </Col>
          <Col xs={24} sm={12} md={8} lg={8}>
            <Input.Search
              size="large"
              value={searchText}
              onInput={(e) => setSearchText(e.target.value)}
              placeholder="Rechercher par nom ou code"
            />
          </Col>
          <Col xs={24} md={8} lg={6}>
            <div style={containerStyle}>
              <div style={labelStyle}>Statut:</div>
              <Select size="large"
                value={statut}
                onChange={(value) => {
                  setStatut(value);
                }}
                placeholder="Filtrer par statut"
                style={{ width: "100%" }}
              >
                <Select.Option value="tout">Tous</Select.Option>
                <Select.Option value="actif">Activé</Select.Option>
                <Select.Option value="inactif">Désactivé</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>
        <Spin spinning={loading}>
          <PersonnelList personnels={personnels} setPersonnels={setPersonnels} paginationData={paginationData} setPaginationData={setPaginationData} searchText={searchText} />
        </Spin>
      </Card>

      <PersonnelCreateForm
        visible={newModalVisible}
        onCreate={handleCreation}
        onCancel={() => setNewModalVisible(false)}
      />
    </Main>
  );
}


PersonnelListPage.propTypes = {
  // renseigner les props du composant ici
};
